// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useFormat } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';

const ResultsCompanyComponent = ({ item, theme = 'teal', wrap = false }) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const { Description__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ResultsCompanyDetails {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

const ResultsCompanyDetails = ({ item, theme }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();
    const format = useFormat();

    // ///////////////////
    // DATA
    // ///////////////////

    const { Year__c, Company_Name__c, Company_Registration__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Various Info */}
            {[Year__c, Company_Name__c, Company_Registration__c].some(
                x => x
            ) && (
                <Card.CardContentPairBox>
                    {Company_Name__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Company_Name__c'
                                ),
                                value: Company_Name__c,
                            }}
                        />
                    )}

                    {Company_Registration__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Company_Registration__c'
                                ),
                                value: Company_Registration__c,
                            }}
                        />
                    )}

                    {Year__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Year__c___Company'
                                ),
                                value: format.year(Year__c),
                            }}
                        />
                    )}
                </Card.CardContentPairBox>
            )}
        </>
    );
};

ResultsCompanyComponent.propTypes = {
    item: t.object,
};

ResultsCompanyComponent.defaultProps = {};

export { ResultsCompanyDetails };
export default ResultsCompanyComponent;
